import ClientIntakeInfo from './ClientIntake';
import CustomFields from './CustomFields';
import MortgageInfo from './MortgageInfo';

const Dashboard = () => {
    return (
        <>
            <ClientIntakeInfo />
            <CustomFields />
            <MortgageInfo />
        </>
    );
}

export default Dashboard;